export default __webpack_public_path__ + "static/media/2.72187b84.jpg";